<template>
  <div id="nav">
    <vs-prompt
      @accept="search"
      @cancel="cancel"
      @close="close"
      :active.sync="showDialog"
      :title="title"
      :accept-text="acceptText"
      :cancel-text="cancelText"
    >
      <div id="dialog-report-search-input-form">
        <span class="mt-6 mb-4">レポートの表示</span>
        <vs-row class="mt-4 mb-6" vs-type="flex">
          <vs-col
            vs-order="1"
            vs-type="flex"
            vs-justify="start"
            vs-align="center"
            vs-w="3"
          >
            <vs-radio v-model="searchConditionCopy.isLatest" vs-value="all"
              >全て</vs-radio
            >
          </vs-col>
          <vs-col
            vs-order="2"
            vs-type="flex"
            vs-justify="start"
            vs-align="center"
            vs-w="5"
          >
            <vs-radio v-model="searchConditionCopy.isLatest" vs-value="latest"
              >各船舶の最新のみ</vs-radio
            >
          </vs-col>
        </vs-row>
        <span class="mt-6 mb-4">連絡期間</span>
        <vs-row class="mt-4 mb-4" vs-type="flex">
          <vs-col
            vs-order="1"
            vs-type="flex"
            vs-justify="start"
            vs-align="center"
            vs-w="5"
          >
            <datepicker
              name="selectExpirationDate"
              :language="ja"
              :format="formatter"
              v-model="searchConditionCopy.fromDate"
            ></datepicker>
          </vs-col>
          <vs-col
            vs-order="2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="1"
          >
            <span>~</span>
          </vs-col>
          <vs-col
            vs-order="3"
            vs-type="flex"
            vs-justify="start"
            vs-align="center"
            vs-w="5"
          >
            <datepicker
              name="selectExpirationDate"
              :language="ja"
              :format="formatter"
              v-model="searchConditionCopy.toDate"
            ></datepicker>
          </vs-col>
        </vs-row>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import DatepickerMixin from "@/mixins/DatepickerMixin";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker,
  },
  mixins: [DatepickerMixin],
  props: {
    searchCondition: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showDialog: false,
      title: "レポートの検索条件",
      acceptText: "検索",
      cancelText: "キャンセル",
      searchConditionCopy: this.searchCondition
    };
  },
  methods: {
    show() {
      this.showDialog = true;
    },
    search() {
      this.$emit('update:searchCondition', this.searchConditionCopy);
      this.$emit("searchReports");
      this.showDialog = false;
    },
    close() {
      this.showDialog = false;
    },
    cancel() {
      this.showDialog = false;
    },
  }
};
</script>

<style lang="scss" scoped>
#dialog-report-search-input-form {
  .vs-input {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  ul li {
    display: inline;
  }
}
</style>
